const _temp0 = require("./render.jsx");
const _temp1 = require("./datalist/index.jsx");

const _temp2 = require("./checkboxes/disabled_option/index.jsx");

const _temp3 = require("./checkboxes/grouped_options/index.jsx");

const _temp4 = require("./checkboxes/object_options/index.jsx");

const _temp5 = require("./checkboxes/string_options/index.jsx");

const _temp6 = require("./checkboxes/with_description/index.jsx");


const _temp7 = require("./combo_box/aria_1_0/index.jsx");

const _temp8 = require("./combo_box/all_disabled_options/index.jsx");

const _temp9 = require("./combo_box/aria_1_1/index.jsx");

const _temp10 = require("./combo_box/aria_1_2_groups/index.jsx");

const _temp11 = require("./combo_box/async_search/index.jsx");

const _temp12 = require("./combo_box/autoselect_disabled_option/index.jsx");

const _temp13 = require("./combo_box/background_autocomplete/index.jsx");

const _temp14 = require("./combo_box/blank_option/index.jsx");

const _temp15 = require("./combo_box/clear_on_select/index.jsx");

const _temp16 = require("./combo_box/close_on_select/index.jsx");

const _temp17 = require("./combo_box/contain_listbox/index.jsx");

const _temp18 = require("./combo_box/disabled/index.jsx");

const _temp19 = require("./combo_box/disabled_option/index.jsx");

const _temp20 = require("./combo_box/fetch/index.jsx");

const _temp21 = require("./combo_box/html_options/index.jsx");

const _temp22 = require("./combo_box/grouped_options/index.jsx");

const _temp23 = require("./combo_box/identical_options/index.jsx");

const _temp24 = require("./combo_box/inline_autocomplete/index.jsx");

const _temp25 = require("./combo_box/layout_listbox/index.jsx");

const _temp26 = require("./combo_box/mapped_options/index.jsx");

const _temp27 = require("./combo_box/listbox_footer/index.jsx");

const _temp28 = require("./combo_box/object_options/index.jsx");

const _temp29 = require("./combo_box/popover/index.jsx");

const _temp30 = require("./combo_box/read_only/index.jsx");

const _temp31 = require("./combo_box/search_min_length/index.jsx");

const _temp32 = require("./combo_box/search_suggestions/index.jsx");

const _temp33 = require("./combo_box/string_options/index.jsx");

const _temp34 = require("./combo_box/tab_select/index.jsx");

const _temp35 = require("./combo_box/very_long_option/index.jsx");

const _temp36 = require("./combo_box/without_autocomplete/index.jsx");


const _temp37 = require("./combo_box_table/combo_box/index.jsx");

const _temp38 = require("./combo_box_table/combo_box_column_width/index.jsx");

const _temp39 = require("./combo_box_table/combo_box_grouped/index.jsx");

const _temp40 = require("./combo_box_table/combo_box_grouped_headers/index.jsx");

const _temp41 = require("./combo_box_table/combo_box_headers/index.jsx");


const _temp42 = require("./drop_down/all_disabled_options/index.jsx");

const _temp43 = require("./drop_down/aria_1_2_groups/index.jsx");

const _temp44 = require("./drop_down/blank_option/index.jsx");

const _temp45 = require("./drop_down/disabled/index.jsx");

const _temp46 = require("./drop_down/disabled_option/index.jsx");

const _temp47 = require("./drop_down/grouped_options/index.jsx");

const _temp48 = require("./drop_down/html_options/index.jsx");

const _temp49 = require("./drop_down/identical_options/index.jsx");

const _temp50 = require("./drop_down/mapped_options/index.jsx");

const _temp51 = require("./drop_down/no_options/index.jsx");

const _temp52 = require("./drop_down/object_options/index.jsx");

const _temp53 = require("./drop_down/placeholder_option/index.jsx");

const _temp54 = require("./drop_down/string_options/index.jsx");

const _temp55 = require("./drop_down/very_long_option/index.jsx");


const _temp56 = require("./drop_down_table/drop_down/index.jsx");

const _temp57 = require("./drop_down_table/drop_down_grouped/index.jsx");

const _temp58 = require("./drop_down_table/drop_down_grouped_headers/index.jsx");

const _temp59 = require("./drop_down_table/drop_down_headers/index.jsx");


const _temp60 = require("./highlighters/delimited/index.jsx");

const _temp61 = require("./highlighters/prefix/index.jsx");

const _temp62 = require("./highlighters/substring/index.jsx");

const _temp63 = require("./highlighters/token/index.jsx");


const _temp64 = require("./radios/disabled_option/index.jsx");

const _temp65 = require("./radios/grouped_options/index.jsx");

const _temp66 = require("./radios/string_options/index.jsx");

const _temp67 = require("./radios/object_options/index.jsx");

const _temp68 = require("./radios/with_description/index.jsx");


const _temp69 = require("./select/disabled_option/index.jsx");

const _temp70 = require("./select/grouped_options/index.jsx");

const _temp71 = require("./select/html_options/index.jsx");

const _temp72 = require("./select/id_options/index.jsx");

const _temp73 = require("./select/large_number_of_options/index.jsx");

const _temp74 = require("./select/mapped_options/index.jsx");

const _temp75 = require("./select/multiple/index.jsx");

const _temp76 = require("./select/multiple_with_disabled/index.jsx");

const _temp77 = require("./select/object_options/index.jsx");

const _temp78 = require("./select/placeholder_option/index.jsx");

const _temp79 = require("./select/string_options/index.jsx");

const _temp80 = require("./select/very_long_option/index.jsx");


module.exports = {
  "render": _temp0,
  "datalist":   {
    "index": _temp1
  },
  "checkboxes":   {
    "disabled_option":     {
      "index": _temp2
    },
    "grouped_options":     {
      "index": _temp3
    },
    "object_options":     {
      "index": _temp4
    },
    "string_options":     {
      "index": _temp5
    },
    "with_description":     {
      "index": _temp6
    }
  },
  "combo_box":   {
    "aria_1_0":     {
      "index": _temp7
    },
    "all_disabled_options":     {
      "index": _temp8
    },
    "aria_1_1":     {
      "index": _temp9
    },
    "aria_1_2_groups":     {
      "index": _temp10
    },
    "async_search":     {
      "index": _temp11
    },
    "autoselect_disabled_option":     {
      "index": _temp12
    },
    "background_autocomplete":     {
      "index": _temp13
    },
    "blank_option":     {
      "index": _temp14
    },
    "clear_on_select":     {
      "index": _temp15
    },
    "close_on_select":     {
      "index": _temp16
    },
    "contain_listbox":     {
      "index": _temp17
    },
    "disabled":     {
      "index": _temp18
    },
    "disabled_option":     {
      "index": _temp19
    },
    "fetch":     {
      "index": _temp20
    },
    "html_options":     {
      "index": _temp21
    },
    "grouped_options":     {
      "index": _temp22
    },
    "identical_options":     {
      "index": _temp23
    },
    "inline_autocomplete":     {
      "index": _temp24
    },
    "layout_listbox":     {
      "index": _temp25
    },
    "mapped_options":     {
      "index": _temp26
    },
    "listbox_footer":     {
      "index": _temp27
    },
    "object_options":     {
      "index": _temp28
    },
    "popover":     {
      "index": _temp29
    },
    "read_only":     {
      "index": _temp30
    },
    "search_min_length":     {
      "index": _temp31
    },
    "search_suggestions":     {
      "index": _temp32
    },
    "string_options":     {
      "index": _temp33
    },
    "tab_select":     {
      "index": _temp34
    },
    "very_long_option":     {
      "index": _temp35
    },
    "without_autocomplete":     {
      "index": _temp36
    }
  },
  "combo_box_table":   {
    "combo_box":     {
      "index": _temp37
    },
    "combo_box_column_width":     {
      "index": _temp38
    },
    "combo_box_grouped":     {
      "index": _temp39
    },
    "combo_box_grouped_headers":     {
      "index": _temp40
    },
    "combo_box_headers":     {
      "index": _temp41
    }
  },
  "drop_down":   {
    "all_disabled_options":     {
      "index": _temp42
    },
    "aria_1_2_groups":     {
      "index": _temp43
    },
    "blank_option":     {
      "index": _temp44
    },
    "disabled":     {
      "index": _temp45
    },
    "disabled_option":     {
      "index": _temp46
    },
    "grouped_options":     {
      "index": _temp47
    },
    "html_options":     {
      "index": _temp48
    },
    "identical_options":     {
      "index": _temp49
    },
    "mapped_options":     {
      "index": _temp50
    },
    "no_options":     {
      "index": _temp51
    },
    "object_options":     {
      "index": _temp52
    },
    "placeholder_option":     {
      "index": _temp53
    },
    "string_options":     {
      "index": _temp54
    },
    "very_long_option":     {
      "index": _temp55
    }
  },
  "drop_down_table":   {
    "drop_down":     {
      "index": _temp56
    },
    "drop_down_grouped":     {
      "index": _temp57
    },
    "drop_down_grouped_headers":     {
      "index": _temp58
    },
    "drop_down_headers":     {
      "index": _temp59
    }
  },
  "highlighters":   {
    "delimited":     {
      "index": _temp60
    },
    "prefix":     {
      "index": _temp61
    },
    "substring":     {
      "index": _temp62
    },
    "token":     {
      "index": _temp63
    }
  },
  "radios":   {
    "disabled_option":     {
      "index": _temp64
    },
    "grouped_options":     {
      "index": _temp65
    },
    "string_options":     {
      "index": _temp66
    },
    "object_options":     {
      "index": _temp67
    },
    "with_description":     {
      "index": _temp68
    }
  },
  "select":   {
    "disabled_option":     {
      "index": _temp69
    },
    "grouped_options":     {
      "index": _temp70
    },
    "html_options":     {
      "index": _temp71
    },
    "id_options":     {
      "index": _temp72
    },
    "large_number_of_options":     {
      "index": _temp73
    },
    "mapped_options":     {
      "index": _temp74
    },
    "multiple":     {
      "index": _temp75
    },
    "multiple_with_disabled":     {
      "index": _temp76
    },
    "object_options":     {
      "index": _temp77
    },
    "placeholder_option":     {
      "index": _temp78
    },
    "string_options":     {
      "index": _temp79
    },
    "very_long_option":     {
      "index": _temp80
    }
  }
}